/**
 * Importers for the Database page. Each one exposes:
 *   { id, title, table, permission | permissions (+ requireAll), modes, parse, plan, apply }
 *   optional: countLabels { <counts key>: label } to override the card's counter labels
 *   optional: plan.warning (string) is shown in red above the counters (removals, archives)
 *   optional: plan.review [{ label, detail }] (amber list of rows to check) and plan.notes [string]
 *
 * Single-file importer (`accept`):
 * - parse(file)                 -> rows (xlsx; the staff importer also reads the MOHRE PDF)
 * - plan(rows, { mode })        -> read-only plan: { counts, samples, ... } (targeted reads only)
 * - apply(plan, { mode, fileName }, onProgress) -> { success, stats, error? }
 *
 * Multi-file importer (`files: [{ id, label, accept, required?: false }]`, the card renders one picker per file):
 * - parse(filesById)            -> rowsById (only the chosen files)
 * - plan(rowsById, { mode })    -> plan; `plan.sections` [{ id, title, table, total, counts, samples, countLabels }] is rendered per section
 * - apply(plan, { mode, fileName, fileNames }, onProgress)
 *
 * Undo (optional):
 * - snapshot(plan, { mode })    -> [{ collection, id, data }] for EVERY document the apply
 *   will create, overwrite or delete; `data` is the current document data, or null when the
 *   document does not exist yet. The card stores it before the apply (importUndoService) so
 *   the import can be rolled back. An importer without `snapshot` (or `storeUndo`) shows
 *   "Undo not available for this table".
 *
 * Only the staff list is imported by hand now. Contracts, airport contracts, customer contacts,
 * the E-Check archive, the fleet, the Invygo bookings and the fuel tank sizes all come from Ejar
 * through the engine's hourly sync, which writes them itself - no manual upload of any list
 * (owner, 28 Sep 2026).
 */
import { staffImporter } from './staffImporter';

export const IMPORTERS = [staffImporter];

export const getImporter = (id) => IMPORTERS.find(i => i.id === id);

export default IMPORTERS;
